module.exports = __webpack_public_path__ + "static/media/deeptanshu.922d2ff1.jpg";